module.exports = __webpack_public_path__ + "static/media/OE-Logo - Main - Colour - RGB.162d45e3.png";